import React from 'react';

import {Footer} from './layout/Footer';
import {Header} from './layout/Header';
import {AboutPage} from './pages/AboutPage';
import {CompanyPage} from './pages/CompanyPage';
import {EventDetailPage} from './pages/EventDetailPage';
import {EventListPage} from './pages/EventListPage';
import {FacilityPage} from './pages/FacilityPage';
import {FaqPage} from './pages/FaqPage';
import {PrivacyPage} from './pages/PrivacyPage';
import {TermsPage} from './pages/TermsPage';
import {TopPage} from './pages/TopPage';
import {TradePage} from './pages/TradePage';

// Pathname routing: public pages use full server-side navigation (no SPA).
// Each <a href> triggers a Rails route → Rails returns shell HTML → React mounts.
// window.location.pathname is read once on mount and never changes within a session.
export const pathToPage = (pathname: string): React.ReactNode => {
  if (pathname === '/') return <TopPage />;
  if (pathname === '/events') return <EventListPage />;
  if (/^\/events\/\d+$/.test(pathname)) return <EventDetailPage />;
  if (pathname === '/about') return <AboutPage />;
  if (pathname === '/company') return <CompanyPage />;
  if (pathname === '/facility') return <FacilityPage />;
  if (pathname === '/faq') return <FaqPage />;
  if (pathname === '/terms') return <TermsPage />;
  if (pathname === '/privacy') return <PrivacyPage />;
  if (pathname === '/trade') return <TradePage />;
  return null;
};

export const PublicApp: React.FC = () => {
  const page = pathToPage(window.location.pathname);
  if (!page) {
    if (process.env.NODE_ENV !== 'production') {
      console.error(
        `PublicApp: no component for pathname "${window.location.pathname}"`,
      );
    }
    return null;
  }
  return (
    <div>
      <Header />
      <main>{page}</main>
      <Footer />
    </div>
  );
};
